<template>
    <div>
  
      <div class="container"  > 
    <div style="margin-bottom: 20px; " size="medium">
      <el-radio-group v-model="radioFilter">
        <el-radio-button label="all">全部数据</el-radio-button>
        <el-radio-button label="high"> 激活7天内试用</el-radio-button>
        <el-radio-button label="low">激活7天以上试用</el-radio-button>
      </el-radio-group>
    </div></div>

      <el-table
    :data="tableData"

    stripe   style="width: 100%"
    :default-sort = "{prop: 'date', order: 'descending'}">

    <el-table-column
      prop="date"
      label="日期"     sortable>
    </el-table-column>
    <el-table-column
      prop="new_trial"
      label="新增试用">
    </el-table-column>
    <el-table-column
      prop="trialing"
      label="试用中">
    </el-table-column>
    <el-table-column
      prop="expiration"
      label="今日到期">
    </el-table-column>
    <el-table-column
      prop="success"
      label="转化成功">
    </el-table-column>
    <el-table-column
      prop="failed"
      label="转化失败">
    </el-table-column>

    <el-table-column
      prop="expiration_roll"
      label="回滚30天到期">
    </el-table-column>
    <el-table-column
      prop="success_roll"
      label="回滚30天转化成功">
    </el-table-column>
    <el-table-column prop="conversion_rate" label="T Conversion Rate"    >
      <template slot-scope="scope">
          <span :style="{ color: getRateColor(scope.row.conversion_rate) }">{{ scope.row.conversion_rate }}</span>
        </template>

    </el-table-column>


    <el-table-column prop="prev_month"   label="Previous Month"    >
      <template slot-scope="scope">
          <span :style="{ color: getRateColor(scope.row.prev_month) }">{{ scope.row.prev_month }}</span>
        </template>
    </el-table-column>


    <el-table-column   prop="prev_year"  label="Previous Year"   >
      <template slot-scope="scope">
          <span :style="{ color: getRateColor(scope.row.prev_year) }">{{ scope.row.prev_year }}</span>
        </template>
    </el-table-column>


    <el-table-column    prop="faild_device"    label="转化失败设备"   width="450">
  <template slot-scope="scope">
    <span v-for="(deviceNumber, index) in scope.row.faild_device.split(',')"
         :key="index"
         class="device-number-link">
      <el-link
        type="primary"
        :underline="false"
        @click.prevent="handleDeviceClick(deviceNumber)">
        {{ deviceNumber.trim() }}
      </el-link>
      <span v-if="index < scope.row.faild_device.split(',').length - 1">, </span>
    </span>
  </template>
</el-table-column>



  </el-table>

  
    </div>
  </template>
  
  <script>


export default {
    data() {
      return {
        tableData: [],
        radioFilter: 'all'
      }
    },
// 新增watch 观察参数变化,如果同一个窗口切换参数的话
    watch: {

    $route(newVal, oldVal) {
      this.getData(newVal.params.bike_type,  newVal.params.filter )
    },
    radioFilter(newV, oldVal) {
      this.$router.replace(`/trialConversion/${this.$route.params.bike_type}/${newV}`)
    }
  },


  // 新建methods 区域, 专门定义各个方法和参数的地方
  methods:{
    async  getData(bike_type,filter){
      //const bike_type = bike_type;
      this.tableData = []
      console.log(filter)
      let res = await this.$http.get("/da/trial_conversion/" + bike_type+"/"+filter)
      this.tableData = res.data
    //    console.log(res.data)
    },

    handleDeviceClick(deviceNumber) {

  const routeData = this.$router.resolve({
    name: 'deviceInfo',
    query: { deviceNumber: deviceNumber.trim() } // 使用查询参数传递 deviceNumber
  });
  // 在新窗口中打开URL
  window.open(routeData.href, '_blank');
},

      getRateColor(percent) {
        const value = parseFloat(percent) / 100
      if (value > 0.85) {
        return 'green'; // 数量小于10，设置颜色为绿色
      } else if (value >=  0.8 && value < 0.85) {
        return 'orange'; // 数量在10到20之间，设置颜色为橙色
      } else {
        return 'red'; // 数量大于等于20，设置颜色为红色
      }
    },
  },
  
  beforeRouteUpdate(to, from, next) {
  // 检查路由参数是否发生变化
  if (to.params.bike_type !== from.params.bike_type || to.params.filter !== from.params.filter) {
    // 更新 el-radio-group 的选择项
    this.radioFilter = to.params.filter;
  }
  next();
},

created:function(){

},



mounted:function(){
  const bike_type = this.$route.params.bike_type;
  const filter = this.$route.params.filter;
this.getData(bike_type,filter)
  console.log("trial_conversion bike_type ="  + bike_type+  "=" + filter+" 挂载完毕")
}

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .container {
    display: flex;
    justify-content: flex-end;
  }
  .device-number-link a {
    color: blue; /* 鼠标悬停时变为蓝色 */
  text-decoration: none; /* 移除下划线 */
}

.device-number-link a:hover {
  color: #ffaa00; /* 点击时变为海思蓝色 */
}

.device-number-link a:active {
  color: inherit; /* 正常状态下使用继承的颜色，即没有特别的颜色 */

}
  </style>
  